module.exports = __webpack_public_path__ + "static/img/WHLH.2608505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bankInfoBg/WHLH.png
// module id = Db4K
// module chunks = 69